import { NgModule } from "@angular/core"
import { RouterModule } from "@angular/router"
import { Routes } from "@angular/router"

import { SearchPageComponent } from "./search-page.component"

const searchRoutes: Routes = [
    { path: "", component: SearchPageComponent },
    { path: "**", redirectTo: "" },
]

@NgModule({
    imports: [RouterModule.forChild(searchRoutes)],
    exports: [RouterModule],
})
export class SearchPageRoutingModule {}
